@use '../proplist/proplist.scss';
@use '../../style/colors.scss';
@use '../../style/mixins.scss';
@use '../../style/functions.scss';

.admonition {
    --size-of-admonition-icon: 2.5rem;
    --border-radius-of-admonition-icon: 0.5rem;

    // Styles for block elements from https://github.com/elviswolcott/remark-admonitions
    border-radius: var(--border-radius-of-admonition-icon);
    background-color: rgb(var(--kompendium-contrast-400));
    margin: functions.pxToRem(12) 0 functions.pxToRem(16) 0;
    padding: functions.pxToRem(8) functions.pxToRem(8) functions.pxToRem(12)
        functions.pxToRem(8);
    position: relative;

    &:before {
        content: '';
        width: var(--size-of-admonition-icon);
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        display: block;
        border-radius: var(--border-radius-of-admonition-icon) 0 0
            var(--border-radius-of-admonition-icon);

        background: {
            position: top center;
            repeat: no-repeat;
            size: contain;
            color: #eaeaea;
        }
    }
    &-tip:before {
        background: {
            image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1.5" clip-rule="evenodd" viewBox="0 0 400 400"><defs/><path fill="none" d="M0 0h400v400H0z"/><circle cx="200" cy="200" r="140.5" fill="%23ffd54f" fill-opacity=".2"/><circle cx="200" cy="200" r="119.072" fill="%23ffd54f" fill-opacity=".3"/><circle cx="200" cy="200" r="99.5" fill="%23ffd54f"/><path fill="%23fff" fill-rule="nonzero" d="M265.384 201.1c0-38.426-33.52-69.494-72.764-64.589-28.615 3.27-52.325 26.163-57.231 54.778-3.27 21.257 4.088 41.696 17.17 55.595 9.81 9.811 14.716 22.892 14.716 36.791h65.406c0-13.081 4.906-26.98 13.899-35.973 11.446-13.082 18.804-28.616 18.804-46.602z"/><path fill="none" stroke="%23ffd54f" stroke-width="8" d="M213.2 194.58C224 188 238 196 231.751 204.881c-9.583 13.619-57.987 11.566-63.709-1.805-3.689-8.622 8.958-14.076 19.439-8.496C196.151 199.196 200.5 207 200.5 224v4"/><path fill="%23446c80" fill-rule="nonzero" d="M232.681 283.675h-65.406c0 18.532 14.171 32.703 32.703 32.703 18.532 0 32.703-14.171 32.703-32.703z"/></svg>');
            color: rgba(var(--kompendium-color-code-yellow), 0.2);
        }
    }

    &-note:before {
        background: {
            image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" clip-rule="evenodd" viewBox="0 0 400 400"><defs/><path fill="none" d="M0 0h400v400H0z"/><circle cx="200" cy="200" r="119.072" fill="%2381c784" fill-opacity=".3"/><circle cx="200" cy="200" r="99.5" fill="%2381c784"/><path fill="%23fff" d="M200.011 145.221c-5.042 0-9.129 4.136-9.129 9.102v54.834a9.094 9.094 0 009.129 9.103c5.043 0 9.13-4.136 9.13-9.103v-54.834a9.093 9.093 0 00-9.13-9.102zm0 109.558a9.13 9.13 0 009.13-9.13 9.129 9.129 0 00-9.13-9.129 9.129 9.129 0 00-9.129 9.129 9.129 9.129 0 009.129 9.13z"/></svg>');
            color: rgba(var(--kompendium-color-code-green-dark), 0.1);
        }
    }

    &-warning:before {
        background: {
            image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" clip-rule="evenodd" viewBox="0 0 400 400"><defs/><path fill="none" d="M0 0h400v400H0z"/><path fill="%23f44336" d="M187.167 113.32c7.091-11.474 18.606-11.446 25.681 0l87.906 142.221c9.467 15.317 2.571 27.734-15.394 27.734H114.655c-17.97 0-24.892-12.367-15.395-27.734l87.907-142.221z"/><path fill="%23fff" d="M200.011 155.052c-5.042 0-9.129 4.136-9.129 9.103v54.833a9.094 9.094 0 009.129 9.103c5.043 0 9.13-4.136 9.13-9.103v-54.833a9.093 9.093 0 00-9.13-9.103zm0 109.558a9.13 9.13 0 009.13-9.13 9.129 9.129 0 00-9.13-9.129 9.129 9.129 0 00-9.129 9.129 9.129 9.129 0 009.129 9.13z"/></svg>');
            color: rgba(var(--kompendium-color-code-pink), 0.2);
        }
    }

    &-danger:before {
        background: {
            image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" clip-rule="evenodd" viewBox="0 0 400 400"><defs/><path fill="none" d="M0 0h400v400H0z"/><path fill="%23446c80" d="M100.7 233.141c-5.6-12.935-8.7-27.173-8.7-42.122C92 131.954 140.393 84 200 84s108 47.954 108 107.019c0 14.949-3.1 29.187-8.7 42.122-4.582 26.722-21.33 48.534-43.425 57.687v12.728c0 10.357-8.485 18.764-18.935 18.764-9.066 0-16.653-6.327-18.504-14.765-1.962 8.291-9.477 14.47-18.436 14.47-9.012 0-16.562-6.251-18.47-14.615-1.909 8.364-9.459 14.615-18.47 14.615-10.45 0-18.935-8.407-18.935-18.764v-12.433c-22.096-9.154-38.844-30.967-43.425-57.687z"/><path fill="%23fff" fill-opacity=".2" d="M213.322 264.164c-3.328 3.135-23.317 3.135-26.644 0-3.332-3.136-3.332-4.928 0-11.199 2.328-4.703 9.832-17.022 13.322-17.022 3.489 0 10.993 12.319 13.322 17.022 3.331 6.271 3.331 8.063 0 11.199z"/><path fill="%23fff" d="M150.179 213.14c12.03 0 21.797 9.678 21.797 21.599s-9.767 21.599-21.797 21.599c-12.03 0-21.797-9.678-21.797-21.599s9.767-21.599 21.797-21.599zm100.844 12.114l8.678-8.598c2.635-2.612 6.896-2.624 9.557.014 2.644 2.619 2.618 6.891.015 9.47l-8.678 8.599 8.678 8.599a6.637 6.637 0 01-.015 9.47c-2.643 2.619-6.954 2.594-9.557.014l-8.678-8.598-8.677 8.598c-2.635 2.612-6.896 2.624-9.558-.014-2.643-2.619-2.617-6.89-.014-9.47l8.678-8.599-8.678-8.599a6.638 6.638 0 01.014-9.47c2.644-2.619 6.954-2.594 9.558-.014l8.677 8.598z"/></svg>');
            color: rgba(var(--kompendium-color-code-gray-dark), 0.1);
        }
    }

    &-info:before {
        background: {
            image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" clip-rule="evenodd" viewBox="0 0 400 400"><defs/><path fill="none" d="M0 0h400v400H0z"/><path fill="%232196f3" fill-rule="nonzero" d="M229.238 275.304c-.075.025-6.987 2.325-12.987 2.325-3.312 0-4.65-.687-5.075-.987-2.1-1.463-6-4.2.675-17.5l12.5-24.924c7.412-14.8 8.512-29.112 3.062-40.312-4.45-9.162-12.987-15.449-23.999-17.699a59.668 59.668 0 00-11.975-1.213c-23.112 0-38.674 13.5-39.324 14.075a6.262 6.262 0 00-1.275 7.825 6.244 6.244 0 007.438 2.775c.062-.025 6.987-2.338 12.987-2.338 3.287 0 4.612.688 5.025.975 2.112 1.475 6.024 4.25-.638 17.525l-12.499 24.937c-7.425 14.812-8.513 29.124-3.063 40.311 4.45 9.162 12.975 15.449 24.012 17.699 3.925.788 7.95 1.213 11.925 1.213 23.124 0 38.698-13.5 39.348-14.075 2.238-1.962 2.763-5.25 1.275-7.825-1.5-2.562-4.612-3.712-7.412-2.787zm-10.487-175.295c17.247 0 31.249 14.002 31.249 31.249s-14.002 31.249-31.249 31.249-31.249-14.002-31.249-31.249 14.002-31.249 31.249-31.249z"/></svg>');
            color: rgba(var(--kompendium-color-code-turquoise), 0.2);
        }
    }

    &-important:before {
        background: {
            image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" clip-rule="evenodd" viewBox="0 0 400 400"><defs/><path fill="none" d="M0 0h400v400H0z"/><path fill="%23ffd54f" fill-rule="nonzero" d="M254.158 293c-2.499 0-4.941-.558-7.205-1.628a9.33 9.33 0 01-1.16-.569l-45.807-26.132-45.806 26.143c-.39.223-.781.413-1.182.591-5.443 2.543-12.101 1.941-16.964-1.595-5.231-3.792-7.819-10.406-6.536-16.83l10.674-51.773c-4.172-3.793-10.73-9.76-17.868-16.251l-21.135-19.239a8.364 8.364 0 01-.87-.915c-4.183-4.416-5.677-10.818-3.792-16.64 1.929-5.845 6.915-10.172 12.937-11.254.38-.089.748-.156 1.138-.201l52.431-5.811 21.705-48.07a7.66 7.66 0 01.669-1.227A16.72 16.72 0 01199.986 93c6.057 0 11.644 3.324 14.6 8.588.234.402.457.814.669 1.249l21.727 48.093 52.431 5.811c.379.033.759.1 1.16.189 6.012 1.116 10.997 5.421 12.916 11.287 1.896 5.811.39 12.247-3.793 16.663-.267.29-.568.603-.87.87l-39.014 35.512 10.674 51.662c1.26 6.547-1.316 13.139-6.58 16.942a16.602 16.602 0 01-9.748 3.134z"/><circle cx="255.5" cy="127.5" r="14.5" fill="%23ffd54f" fill-opacity=".5"/><circle cx="144.5" cy="127.5" r="14.5" fill="%23ffd54f" fill-opacity=".5"/><circle cx="287.5" cy="229.5" r="14.5" fill="%23ffd54f" fill-opacity=".5"/><circle cx="113.5" cy="229.5" r="14.5" fill="%23ffd54f" fill-opacity=".5"/><circle cx="200" cy="297.5" r="14.5" fill="%23ffd54f" fill-opacity=".5"/></svg>');
            color: rgba(var(--kompendium-color-code-gray-dark), 0.4);
        }
    }
}

.admonition-heading {
    margin-bottom: functions.pxToRem(6);

    h5 {
        color: rgb(var(--kompendium-contrast-1100));
        margin: 0;
        font-size: functions.pxToRem(15);
        padding: functions.pxToRem(2) 0 0 var(--size-of-admonition-icon);

        &::first-letter {
            text-transform: capitalize;
        }
    }
}

.admonition-content {
    padding-left: var(--size-of-admonition-icon);

    p {
        &:first-child {
            margin-top: 0;
        }
        &:only-child {
            margin-bottom: 0;
        }
    }
}

@media (max-width: 600px) {
    .admonition {
        --size-of-admonition-icon: 2rem;
    }
}

blockquote {
    border-left-color: rgb(var(--kompendium-contrast-700));
    border-left-style: solid;
    border-left-width: 0.25rem;
    color: rgb(var(--kompendium-contrast-1100));
    padding-left: 1rem;
}
